import clsx from 'clsx';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { useStyles } from './styles';
import { useModal } from 'contexts/EmailFormModalContext';

const Props = {
  variant: PropTypes.oneOf([
    'text',
    'outlined',
    'outlined-new',
    'buttonWhite',
    'buttonSecondary',
    'buttonWhiteTextPurple',
    'transparentButtonBorderWhite',
    'ctaPinkOpenModal',
    'ctaPink',
    'ctaBlue',
    'ctaPrimaryOpenModal',
    'ctaPrimaryOutlineOpenModal',
    'ctaPrimaryOutline',
    'buttonSecondaryOpenModal',
    'ctaPinkOutline',
    'ctaDarkPinkOpenModal',
    'ctaPinkOpenUrl',
    'ctaPrimaryOutlineOpenUrl',
    'contained',
    'customGrayOutline',
    'contactMessage',
  ]),
  color: PropTypes.oneOf(['primary']),
};

function openTargetPage(url) {
  window.location.href = url;
}

function CustomButton({ children, variant, color, targetPage, ...rest }) {
  const classes = useStyles();
  const { setIsModalOpen } = useModal();

  if (variant === 'contained') {
    return;
  }

  if (variant === 'text') {
    return (
      <Button
        {...rest}
        className={clsx(classes.root, {
          [classes.textPrimary]: color === 'primary',
        })}
      >
        {children}
      </Button>
    );
  }

  if (variant === 'outlined') {
    return (
      <Button {...rest} variant="outlined" className={classes.root}>
        {children}
      </Button>
    );
  }

  if (variant === 'outlined-new') {
    return (
      <Button {...rest} variant="outlined" className={classes.outlinedNew}>
        {children}
      </Button>
    );
  }

  if (variant === 'buttonWhite') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.buttonWhite)}>
        {children}
      </Button>
    );
  }

  if (variant === 'buttonSecondary') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.buttonSecondary)}>
        {children}
      </Button>
    );
  }

  if (variant === 'buttonWhiteTextPurple') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.buttonWhiteTextPurple)}>
        {children}
      </Button>
    );
  }

  if (variant === 'transparentButtonBorderWhite') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.transparentButtonBorderWhite)}>
        {children}
      </Button>
    );
  }
  if (variant === 'ctaPink') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.ctaPink)}>
        {children}
      </Button>
    );
  }
  if (variant === 'ctaBlue') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.ctaBlue)}>
        {children}
      </Button>
    );
  }

  if (variant === 'ctaPinkOpenModal') {
    return (
      <Button {...rest} onClick={setIsModalOpen} className={clsx(classes.root, classes.ctaPink)}>
        {children}
      </Button>
    );
  }

  if (variant === 'ctaDarkPinkOpenModal') {
    return (
      <Button
        {...rest}
        onClick={setIsModalOpen}
        className={clsx(classes.root, classes.ctaPrimaryPink)}
      >
        {children}
      </Button>
    );
  }

  if (variant === 'ctaPinkOpenUrl') {
    return (
      <Button
        {...rest}
        onClick={() => openTargetPage(targetPage)}
        className={clsx(classes.root, classes.ctaPink)}
      >
        {children}
      </Button>
    );
  }

  if (variant === 'ctaPrimaryOpenModal') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.ctaPrimary)} onClick={setIsModalOpen}>
        {children}
      </Button>
    );
  }

  if (variant === 'ctaPrimaryOutlineOpenModal') {
    return (
      <Button
        {...rest}
        className={clsx(classes.root, classes.ctaPrimaryOutline)}
        onClick={setIsModalOpen}
      >
        {children}
      </Button>
    );
  }

  if (variant === 'ctaPrimaryOutlineOpenUrl') {
    return (
      <Button
        {...rest}
        className={clsx(classes.root, classes.ctaPrimaryOutline)}
        onClick={() => openTargetPage(targetPage)}
      >
        {children}
      </Button>
    );
  }

  if (variant === 'ctaPrimaryOutline') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.ctaPrimaryOutline)}>
        {children}
      </Button>
    );
  }

  if (variant === 'ctaPinkOutline') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.ctaPinkOutline)}>
        {children}
      </Button>
    );
  }

  if (variant === 'customGrayOutline') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.customGrayOutline)}>
        {children}
      </Button>
    );
  }

  if (variant === 'contactMessage') {
    return (
      <Button {...rest} className={clsx(classes.root, classes.contactMessage)}>
        {children}
      </Button>
    );
  }

  if (variant === 'buttonSecondaryOpenModal') {
    return (
      <Button
        {...rest}
        className={clsx(classes.root, classes.buttonSecondaryOpenModal)}
        onClick={setIsModalOpen}
      >
        {children}
      </Button>
    );
  }
  return (
    <Button {...rest} className={clsx(classes.root, classes.containedPrimary)} variant="contained">
      {children}
    </Button>
  );
}

CustomButton.propTypes = Props;

const CButton = forwardRef((props, ref) => <CustomButton {...props} />);
CButton.displayName = 'CustomButton';

export default CButton;
